module.exports = __webpack_public_path__ + "assets/img/script_data_default.291e4c75.jpg";